export default __webpack_public_path__ + "static/media/sleet.0083c56e.svg";